<template>
  <div>
    <modal-container v-if="modalActive">
      <company-logo-picker :company="company" @close="modalActive = false"></company-logo-picker>
    </modal-container>
    <div class="text-center">
      <div class="logo-container">
        <div v-if="company.activeLogo">
          <img
            :src="'https://s3.us-east-2.amazonaws.com/panelvue-photos/logo/' + company.activeLogo.uuid"
            class="logo"
          />
        </div>
        <div v-else>(No Logo)</div>
      </div>
      <button class="btn btn-primary" @click="modalActive = true">Change Logo</button>
    </div>
  </div>
</template>

<script>
import ModalContainer from "@/components/ModalContainer";
import CompanyLogoPicker from "@/components/CompanyLogoPicker";

export default {
  name: "company-logo",
  components: { ModalContainer, CompanyLogoPicker },
  props: ["company"],
  data: () => ({
    loading: true,
    error: "",
    filter: "",
    modalActive: false
  }),
  methods: {
    uploadImage(e, company) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      company.file = files[0];
    },
    async saveCompany(company) {
      try {
        company.error = "";
        company.loading = true;
        const response = await this.$web.updateCompanyLogo(company);
        if (response.data.companies) {
          // TODO handle response
        } else {
          this.error = "Failed to update logo";
        }
      } catch (e) {
        company.loading = false;
        if (e.response && e.response.status === 413) {
          company.error = "File too large.";
        } else {
          company.error = "Failed to update company.";
        }
      }
    }
  },
  async mounted() {}
};
</script>

<style scoped>
.logo {
  max-width: 3in;
  max-height: 0.75in;
  object-fit: contain;
}

.logo-container {
  height: 0.89in;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
